import { PixagriField } from 'library/src/fields/models/PixagriField';
import { FieldIrrigationService } from 'library/src/fields/models/WagoField';
import log from 'shared/services/LogService';

export function getRotation(
  rotationId: number | string,
  fieldsData: PixagriField[],
): FieldIrrigationService | null | undefined {
    let rotation: FieldIrrigationService | null = null;
  if (fieldsData) {
    fieldsData.forEach((field) => {

        if (field.irrigation && field.irrigation.length) {
                    

            const selectedRotation = field.irrigation.find(rotation => rotation.rotation_id === (typeof rotationId === "string" ? parseInt(rotationId) : rotationId));
           
            if (selectedRotation && rotation) {
                log.error(`Multiple rotation with id ${rotationId} found for field ${field.field_id}`); // Log an error if multiple rotations with the same ID are found
            } 
            if (selectedRotation) {
                rotation = selectedRotation;
            }
            
        }
    })
    /*for (let i = 0; i < fieldsListByCampaign.length; i++) {
      const fieldList = Object.values(fieldsListByCampaign[i]);
      for (let j = 0; j < fieldList.length; j++) {
        if (fieldList[j].irrigation && fieldList[j].irrigation.length) {
          const selectedRotation = fieldList[j].irrigation.find(
            // eslint-disable-next-line eqeqeq
            (rot) => rot.rotation_id == rotationId,
          );
          if (selectedRotation) {
            rotation = selectedRotation;
          }
        }
      }
    }*/
    if (!rotation) {
      log.error(`Rotation with id ${rotationId} not found`);
      return null;
    }
    return rotation;
  }
}
